// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-container {
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  padding: 0 24px 24px;
}

.files {
  display: flex;
  flex-direction: column;
}

.file-content {
  display: flex;
  flex-direction: column;
  padding: 10px 24px;
}

.file-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.file-header-info {
  display: flex;
  flex-direction: column;
}

.file-button {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: 0.4px;
}

#fileUpload {
  position: absolute;
  z-index: 9;
  opacity: 0;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  cursor: pointer;
}

.mat-form-field {
  width: 100%;
}

.mat-toolbar-single-row {
  height: auto !important;
  background: transparent;
}
.mat-toolbar-single-row button {
  width: 30%;
}

.file-card-container {
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 0;
  padding: 0 !important;
}
.file-card-container.uploader {
  padding: 8px 8px 8px 16px !important;
}
.file-card-container .content-card {
  border: 1px solid #dfdee5;
  border-radius: 4px;
  justify-content: center;
  display: inline-block;
}
.file-card-container .content-card > div {
  display: flex;
  padding-top: 11px;
  padding-bottom: 11px;
  align-items: center;
  padding-right: 8px;
}

.file-card-preview {
  width: 50px;
  height: 75px;
  padding-right: 10px;
}

:host ::ng-deep app-file-cards .file-card-container {
  border-color: #dfdee5;
  padding: 7px 0 !important;
}
.dark-theme :host ::ng-deep app-file-cards .file-card-container .content-card {
  border: 1px solid rgba(211, 211, 211, 0.3);
}
:host ::ng-deep app-file-cards .more-vert, :host ::ng-deep app-file-cards .drag-indicator {
  color: #dfdee5;
  align-self: self-start;
  top: 8px;
  position: relative;
  cursor: pointer;
}
.dark-theme :host ::ng-deep app-file-cards .more-vert, :host .dark-theme :host ::ng-deep app-file-cards .drag-indicator {
  color: rgba(211, 211, 211, 0.3) !important;
}
:host ::ng-deep app-file-cards .drag-indicator {
  position: relative;
  padding-left: 4px;
}
:host ::ng-deep app-file-cards .card-text {
  padding-left: 16px !important;
  color: rgba(13, 2, 35, 0.56);
  min-height: 42px;
  display: flex;
  align-items: center;
  padding-right: 9px;
}
.dark-theme :host ::ng-deep app-file-cards .card-text {
  color: white;
}
:host ::ng-deep app-file-cards .card-text.orderable {
  padding-left: 9px !important;
}
:host ::ng-deep app-file-cards table#files {
  height: 310px;
  overflow: auto;
}
:host ::ng-deep app-file-cards table#files tr {
  margin: 0 !important;
  padding: 0 !important;
  margin-bottom: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/core/components/workbooks/workbook-builder/files/files.scss"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;AALF;;AAUA;EACE,aAAA;EACA,sBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAPF;;AASA;EACE,aAAA;EACA,sBAAA;AANF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AALF;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;AALF;;AAOE;EACM,WAAA;AAJR;;AAOI;EACI,uBAAA;EACA,uBAAA;AAJR;AAMQ;EACI,UAAA;AAJZ;;AAOA;EAEE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;AALF;AAME;EACE,oCAAA;AAJJ;AAkBE;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;AAhBJ;AAkBI;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAhBN;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAjBF;;AAsBI;EACE,qBAAA;EACA,yBAAA;AAnBN;AAqBQ;EACE,0CAAA;AAnBV;AAuBI;EACE,cAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AArBN;AAsBM;EACE,0CAAA;AApBR;AAuBI;EAEE,kBAAA;EAEA,iBAAA;AAvBN;AAyBI;EACE,6BAAA;EACA,4BAAA;EAOA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA7BN;AAoBM;EACE,YAAA;AAlBR;AAoBM;EACE,4BAAA;AAlBR;AAyBI;EACE,aAAA;EACA,cAAA;AAvBN;AAwBM;EACE,oBAAA;EACA,qBAAA;EACA,6BAAA;AAtBR","sourcesContent":["// @import \"../../../../../styles.scss\";\n@import \"../../../../../variable/_variable.scss\";\n// @import \"../../../../../component_variable.scss\";\n.container{\n  // background-color: $primary-light;\n}\n.file-container{\n  display: flex;\n  flex-direction: column;\n  border-radius: 0px;\n  padding: 0 24px 24px;\n}\n.files_search_container{\n  // background-color: $primary-dark-background;\n}\n.files{\n  display: flex;\n  flex-direction: column;\n  // flex-wrap: wrap;\n}\n.file-content{\n  display: flex;\n  flex-direction: column;\n  padding: 10px 24px;\n  // background: $primary-dark-background-color;\n}\n.file-header{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.file-header-info{\n  display: flex;\n  flex-direction: column;\n}\n.file-button{\n  font-size: 14px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.14;\n  letter-spacing: 0.4px;\n  // color: $primary;\n}\n#fileUpload {\n  position: absolute;\n  z-index: 9;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  left: 0px;\n  top: 0px;\n  cursor: pointer;\n}\n  .mat-form-field {\n        width: 100%;\n    }\n\n    .mat-toolbar-single-row {\n        height: auto !important;\n        background: transparent;\n\n        button {\n            width: 30%;\n        }\n    }\n.file-card-container{\n  // background-color: $whizzimo-modal-background;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  border: 0;\n  padding: 0 !important;\n  &.uploader {\n    padding: 8px 8px 8px 16px !important;\n  }\n  // width: 100vw;\n  // color: $whizzimo-black-white;\n  span{\n    &:first-child{\n      // color: rgba($whizzimo-black-white, 0.87);\n    }\n  }\n  button{\n    mdc-button__label{\n      // color: rgba($whizzimo-black-white, 0.87);\n    }\n  }\n  .content-card {\n    border: 1px solid #dfdee5;\n    border-radius: 4px;\n    justify-content: center;\n    display: inline-block;\n    // padding: 11px 0 !important;\n    > div {\n      display: flex;\n      padding-top: 11px;\n      padding-bottom: 11px;\n      align-items: center;\n      padding-right: 8px;\n    }\n  }\n}\n.file-card-preview{\n  width: 50px;\n  height: 75px;\n  padding-right: 10px;\n}\n\n:host ::ng-deep {\n  app-file-cards {\n    .file-card-container {\n      border-color: #dfdee5;\n      padding: 7px 0 !important;\n      .content-card {\n        .dark-theme & {\n          border: 1px solid rgba(211, 211, 211, 0.3);\n        }\n      }\n    }\n    .more-vert {\n      color: #dfdee5;\n      align-self: self-start;\n      top: 8px;\n      position: relative;\n      cursor: pointer;\n      .dark-theme & {\n        color: rgba(211, 211, 211, 0.3) !important;\n      }\n    }\n    .drag-indicator {\n      @extend .more-vert;\n      position: relative;\n      // top: 7px;\n      padding-left: 4px;\n    }\n    .card-text {\n      padding-left: 16px !important;\n      color: rgba(13, 2, 35, 0.56);\n      .dark-theme & {\n        color: white;\n      }\n      &.orderable {\n        padding-left: 9px !important;\n      }\n      min-height: 42px;\n      display: flex;\n      align-items: center;\n      padding-right: 9px;\n    }\n    table#files {\n      height: 310px;\n      overflow: auto;\n      tr {\n        margin: 0 !important;\n        padding: 0 !important;\n        margin-bottom: 8px !important;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
